import type { ReactElement } from 'react';
import { Card } from '@fastnorth/react-cerberus/Card';

export type NotFoundProps = {
  message?: string;
  cerbiconUri?: string;
};

const NotFound = ({
  message = 'The gallery you are looking for could not be found…',
  cerbiconUri = 'https://cdn.raceroster.com/assets/cerbicons/empty-404--forest.svg',
}: NotFoundProps): ReactElement => (
  <Card>
    <Card.Body className={'d-flex flex-column flex-sm-col justify-content-center align-items-center flex-wrap'}>
      <img src={cerbiconUri} alt={'Are you lost?'} className={'p-4'} />
      <p className={'text-center'}>{message}</p>
    </Card.Body>
  </Card>
);

export default NotFound;
